on("click", "[data-open-dialog]", function () {
	const modal = $(this).data("open-dialog");

	$("#" + modal)[0].showModal();
});
